import { useState } from 'react'

import { Box, Colors, Icon, Text, ThemeColors } from '@factorialco/deprecated-design-system'

import Chip from 'modules/core/components/Filter/base/Chip'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import i18n from 'modules/core/lib/i18n'

export interface FilterOption {
  label: string
  value: string
}

export type FilterOptions = FilterOption[]

interface AddFilterProps {
  availableFilters: FilterOptions
  onSelectFilter: (filter: string) => void
  color?: Colors | ThemeColors
}

const AddFilterContent = ({ availableFilters, onSelectFilter }: AddFilterProps) => {
  return (
    <Content
      body={
        <Box flexDirection="column">
          {availableFilters.map(({ label, value }) => (
            <Box
              gap="s12"
              key={value}
              paddingX="s16"
              paddingY="s12"
              component="button"
              flexDirection="row"
              justifyContent="spaceBetween"
              onClick={() => onSelectFilter(value)}
            >
              <Text.Normal size="300" color="grey800" ellipsis>
                {label}
              </Text.Normal>
            </Box>
          ))}
        </Box>
      }
    />
  )
}

const AddFilter = ({ onSelectFilter, availableFilters, color = 'grey700' }: AddFilterProps) => {
  const [open, setOpen] = useState<boolean>(false)

  if (availableFilters.length === 0) {
    return null
  }

  const onCurrentFilterSelect = (value: string) => {
    const filter = availableFilters.find((availableFilter) => availableFilter.value === value)
    if (filter) {
      setOpen(false)
      onSelectFilter(filter.value)
    }
  }

  return (
    <Provider
      open={open}
      setOpen={setOpen}
      defaultOpen={false}
      onValueChange={onCurrentFilterSelect}
    >
      <Chip.Toggler
        noBorder
        hideChevron
        active={false}
        label={
          <Box gap="s4" flexDirection="row" alignItems="center">
            <Icon.Small icon="add" color={color} />
            <Text.Normal size="200" color={color}>
              {i18n.t('data_table.filters.add_filter')}
            </Text.Normal>
          </Box>
        }
      />
      <AddFilterContent
        availableFilters={availableFilters}
        onSelectFilter={onCurrentFilterSelect}
      />
    </Provider>
  )
}

export default AddFilter
